import type { OrganizationPendingInvite } from '../types';
import apiRequest from './apiRequest';

export default async function getOrganizationInvites(organizationID: string) {
  return apiRequest<{ invites: OrganizationPendingInvite[] }>(
    'user',
    `/organizations/${encodeURIComponent(organizationID)}/invites`,
  );
}
